export class FacturaElectronica {
  numeroAutorizacion: string;
  codigoSAP: string;
  }